export const LAYOUT_DEFAULT = 'default';
export const LAYOUT_DOCUMENTS = 'documents';
export const LAYOUT_DOCUMENTS_FULL = 'documents-full';
export const LAYOUT_DOCUMENTS_1_3 = 'documents-1-3';

export type Layout = 'default' | 'documents' | 'documents-full' | 'documents-1-3';
